import { Injectable } from '@angular/core';
import { GetPeopleDataByEmailResponseDto } from '@fdm/api-client';

@Injectable({
  providedIn: 'root'
})
export class EmailDescriptionService {

  processOwnerDescriptions(owners: GetPeopleDataByEmailResponseDto[]): string {
    if (!owners || owners.length === 0) {
      return '';
    }

    return owners
      .map(owner => {
        let description = owner.description ?? '';
        // Remove only the email part: ", email: xxx@xxx.com" but keep phone
        description = description.replace(/, email:\s*[^,]+/, '');
        return description;
      })
      .join('\n');
  }

   getPreferredEmail(owners: GetPeopleDataByEmailResponseDto[]): string | null {
    if (!owners || owners.length === 0) {
      return null;
    }
 
    // const owner = owners[0];
    const owner = owners[owners.length - 1];
    if (owner.sharedEmail && owner.sharedEmail.trim() !== '') {
      return owner.sharedEmail;
    } else if (owner.preferredEmail && owner.preferredEmail.trim() !== '') {
      return owner.preferredEmail;
    }
    return null;
  }

  getPreferredEmailForApprovalFlow(owners: GetPeopleDataByEmailResponseDto[]): string | null {
    if (!owners || owners.length === 0) {
      return null;
    }

    const firstPreferredEmail = owners
      .map(owner => owner.preferredEmail?.trim())
      .find((email): email is string => !!email);

    if (firstPreferredEmail) {
      return firstPreferredEmail;
    }

    const firstSharedEmail = owners
      .map(owner => owner.sharedEmail?.trim())
      .find((email): email is string => !!email);

    return firstSharedEmail ?? null;
  }
}
